/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaDatePicker from 'DesignSystem/TysiaDatePicker/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  closePopover,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Main/Board/Board/Content/Card/DueDate/Content"
  
}) {
let cardDueDateValueData = fromData.useDataValue({ viewPath,
context: 'card',
path: 'due_date',
})
let aggregateData = fromAggregate.getValueOrDefault(cardDueDateValueData)
let onChange = fromHelpers.useOnChange({
  children,
  closePopover,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaDatePicker
  viewPath={`${viewPath}/TysiaDatePicker`}
 data="card.due_date"
 aggregate="/Data/aggregate.js getValueOrDefault"
 value={aggregateData}
 onChange={onChange}
/>
{children}
</React.Fragment>)
}